<template>
    <div class='record records-list__record'>
        <button class='record__play-button' v-on:click='switchOnOff'>
            <font-awesome-icon class="record__play-button-icon"
				icon='play'
                v-if='!record.isActive'
            ></font-awesome-icon>
            <font-awesome-icon class="record__play-button-icon"
                icon='pause'
                v-if='record.isActive'
            ></font-awesome-icon>
        </button>
        <div class='record__wrapper'>
            <span class='record__name'>{{ record.name }} </span>
            <div class='record__time-line'
				v-if='record.isActive'
            ></div>
        </div>
        <span class='record__duration'>{{ record.record.duration }}</span>
    </div>
</template>

<script>
export default {
    name: 'Record',
    props: ['record', 'index'],
    data: function() {
        return {
        }
    },
    methods: {
    	switchOnOff: function() {
            if(!this.record.isActive) this.record.record.play();
                else this.record.record.pause();
    		this.$emit('switch', this.index);
    	}
    }
}
</script>

<style lang='less'>
.record {
    width: 300px;
    height: 56px;
    border-radius: 20px;
    background-color: #41B883;
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-weight: 900;
    font-size: 13px;
    line-height: 100%;
    color: #E4FFF4;
	
	&__wrapper {
		display: flex;
		flex-direction: column;
        justify-content: center;
		width: 187px;
		height: 100%;
	}

	&__time-line {
		width: 100%;
		height: 2px;
		background-color: #E4FFF4;
		margin-top: 4px;
        display: none;
	}

    &__play-button {
        width: 23px;
        height: 26px;
        margin: 0 14px 0 21px;
        border: none;
        background-color: transparent;
        padding: 0;

        &-icon {
            font-size: 23px;
            color: #E4FFF4;
        }
    }

    &__duration {
        margin-left: 14px;
        display: none;
    }
}

.records-list__record {
    margin-bottom: 16px;
}
</style>